import React from 'react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

export const AboutSection = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container-professional" ref={elementRef} style={getRevealStyle()}>
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs uppercase tracking-[0.2em] text-primary font-mono mb-4">
              About
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              About Affinity Aim
            </h2>
          </div>
          <div className="space-y-6">
            <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed">
              Affinity Aim is a small product studio that builds custom apps and internal tools for B2B teams. We work with businesses that have a specific problem to solve and need something built properly, not another subscription to software that almost fits.
            </p>
            <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed">
              We started Affinity Aim because we kept running into the same situation: a business with a clear process problem and no ready-made tool that actually solved it. Building the right tool turned out to be faster and more affordable than most people expect.
            </p>
            <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed">
              Our clients are typically service businesses, sales teams, and B2B companies. They come to us when a spreadsheet is breaking, a process is relying too heavily on one person, or a sales team is spending time on manual work that should be automated. We figure out what needs to be built, then build it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
